import styled from 'styled-components';

const StyledWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .loading {
    left: 0;
    z-index: 2;
  }
`;

export default StyledWrapper;
